import { FC, useRef, useState } from 'react';
import '../styles/EditStudentInfoDialog.css'
import closeIcon from '../images/close-icon.svg'
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import DatePickerInput from './DatePickerInput';
import LinearProgressBar from './LinearProgressBar';
import SnackbarAlert from './SnackbarAlert';
import axios from 'axios';

interface Props {
    handleClickClose: () => void
}

const CreateNewSemesterDialog: FC<Props> = ({
    handleClickClose
}) => {
    const [loading, setLoading] = useState(false)
    
    const [year, setYear] = useState<string>('')
    const [semester, setSemester] = useState<string>('')
    const [startDate, setStartDate] = useState<null | moment.Moment>(null)
    const [endDate, setEndDate] = useState<null | moment.Moment>(null)

    const [snackbarMessage, setSnackbarMessage] = useState<null | {
        message: string,
        severity?: 'success' | 'info' | 'warning' | 'error',
        autoHideDuration?: number | null
    }>(null)

    const handleSubmit = () => {
        const checkInput = year && semester && startDate && endDate
        setSnackbarMessage(null)
        setLoading(true)
        if (!checkInput) {
            setSnackbarMessage({ message: 'Please fill in all required information', severity: 'warning', autoHideDuration: 3000 })
            setLoading(false)
        } else {
            axios.post(`/Semesters`, {
                year: year,
                no: semester,
                startDate: startDate?.format('YYYY-MM-DD'),
                endDate: endDate?.format('YYYY-MM-DD')
            }).then(res => {
                console.log(res)
                setSnackbarMessage({ message: 'Create new semester successfully', severity: 'success', autoHideDuration: 1500 })
                setTimeout(() => {
                    setLoading(false)
                    handleClickClose()
                }, 2000)
            }
            ).catch(err => {
                console.log(err)
                if (err.response.status === 409) setSnackbarMessage({ message: 'Semester already exists', severity: 'error', autoHideDuration: 3000 })
                else if (err.response.status === 400) setSnackbarMessage({ message: 'Invalid input', severity: 'error', autoHideDuration: 3000 })
                else setSnackbarMessage({ message: 'Something went wrong', severity: 'error', autoHideDuration: 3000 })
                setLoading(false)
            })
        }
    }

    return (
        <div className="EditDueDateDialog">
            <div className="EditDueDateDialog-dialog common-goal">
                <button className="ProgressDialog-close-button" onClick={handleClickClose}>
                    <img src={closeIcon} width={24} height={24} alt="close-icon" />
                </button>
                {
                    (loading) &&
                    <div className="ProgressDialog-linear-progress">
                        <LinearProgressBar />
                    </div>
                }
                <div className="AddStudentDialog-header-container">
                    <h4 className='AddStudentDialog-title'>Create</h4>
                    <h4 className='AddStudentDialog-goal-name'>New Semester</h4>
                </div>
                <div className="EditStudentInfoDialog-form-container">
                    <div className='flex-column gap1-dot5'>
                        <div className='flex gap1'>
                            <TextField label="ปีการศึกษา" placeholder='25XX' variant="outlined" value={year} onChange={(e) => setYear(e.target.value)} type="number" InputProps={{ inputProps: { min: 0, max: 9999 } }} disabled={loading} required fullWidth />
                            <TextField id="select" label="ภาคเรียนที่" variant="outlined" defaultValue={''} value={semester} onChange={(e) => setSemester(e.target.value)} disabled={loading} select required fullWidth>
                                <MenuItem key={1} value={1}>{1}</MenuItem>
                                <MenuItem key={2} value={2}>{2}</MenuItem>
                            </TextField>
                        </div>
                        <div className='flex gap1'>
                            <DatePickerInput
                                label="วันเปิด"
                                emptyLabel=''
                                inputVariant='outlined'
                                selectedDate={startDate}
                                setSelectedDate={setStartDate}
                                disabled={loading}
                                clearable={true}
                                required
                            />
                            <DatePickerInput
                                label="วันปิด"
                                emptyLabel=''
                                inputVariant='outlined'
                                selectedDate={endDate}
                                setSelectedDate={setEndDate}
                                disabled={loading}
                                clearable={true}
                                required
                            />
                        </div>
                    </div>
                    <div className="ProgressDialog-bottom-container" >
                        <div className="ProgressDialog-actions" style={{ marginLeft: 'auto' }}>
                            <button className="ProgressDialog-button" type='button' onClick={handleClickClose}>Cancel</button>
                            <button className="ProgressDialog-button" type="submit" disabled={(loading || !year || !semester || !startDate || !endDate)} onClick={handleSubmit}>Create</button>
                        </div>
                    </div>

                </div>
            </div>
            {
                (snackbarMessage) &&
                <SnackbarAlert severity={snackbarMessage.severity} message={snackbarMessage.message} />
            }
        </div>
    );
}

export default CreateNewSemesterDialog;